export interface NavItemProps {
  id: string;
  messageId: string;
  title: string;
  icon?: string;
  exact?: boolean;
  url?: string;
  type?: string;
  count?: number;
  color?: string;
  auth?: string[];
  children?: NavItemProps[] | NavItemProps;
}

const routesConfig: NavItemProps[] = [
  {
    id: 'transactions',
    title: 'Transactions',
    messageId: 'p1.transactions',
    type: 'group',
    icon: 'work',
    children: [
      {
        id: 'transactions-main',
        title: 'Transaction',
        messageId: 'p1.transactions.main',
        type: 'item',
        url: '/transactions/main',
      },
    ],
  },
  {
    id: 'settings',
    title: 'Settings',
    messageId: 'p1.settings',
    type: 'group',
    icon: 'settings',
    children: [
      {
        id: 'settings-compiledScripts',
        title: 'Scripts',
        messageId: 'p1.settings.compiledScripts',
        type: 'item',
        url: '/settings/compiledScripts/main',
      },
      {
        id: 'settings-documents',
        title: 'Documents',
        messageId: 'p1.settings.documents',
        type: 'item',
        url: '/settings/documents/main',
      },
      {
        id: 'settings-processes',
        title: 'Processes',
        messageId: 'p1.settings.processes',
        type: 'item',
        url: '/settings/processes/main',
      },
      {
        id: 'settings-tradingPartners',
        title: 'Trading Partners',
        messageId: 'p1.settings.tradingPartners',
        type: 'item',
        url: '/settings/tradingPartners/main',
      },
      {
        id: 'settings-xferTables',
        title: 'Cross Reference Tables',
        messageId: 'p1.settings.xferTables',
        type: 'item',
        url: '/settings/xferTables/main',
      },
      {
        id: 'settings-endpoints',
        title: 'Endpoints',
        messageId: 'p1.settings.endpoints',
        type: 'item',
        url: '/settings/endpoints/main',
      },
      {
        id: 'settings-notifications',
        title: 'Notifications',
        messageId: 'p1.settings.notifications',
        type: 'item',
        url: '/settings/notifications/main',
      }
    ],
  },
];
export default routesConfig;
